import React, { createContext, useState } from 'react';
import Spotlight from './spotlight';

interface SpotlightContextType {
    getSpotlight: (id: string, mediaId: number) => string;
    renderAllSpotlights: () => React.ReactNode;
    freeSpotlight: (pairId: string) => void;
    updateSpotlightPortal: (pairId: string, newPortalId: string, mediaId: number) => void;
}

export const SpotlightContext = createContext<SpotlightContextType>({
	getSpotlight: () => '',
	renderAllSpotlights: () => <></>,
	freeSpotlight: () => {},
	updateSpotlightPortal: () => {},
});
interface Props {
    children?: React.ReactNode;
}
const SpotlightContextProvider: React.FC<Props> = ({ children }) => {
	const [spotlights, setSpotlights] = useState< Map<string, React.ReactNode>>(new Map());
	const updateSpotlightPortal = (spotlightId: string, newPortalId: string, mediaId: number) => {
		const spotLight = (<Spotlight mediaId={mediaId} key={`spotlight-${spotlightId}`} spotlightId={spotlightId} elementToPortal={newPortalId} />);
		setSpotlights((prev) => new Map(prev).set(spotlightId, spotLight));
	};

	const freeSpotlight = (spotlightId: string) => {
		setSpotlights((prev) => {
			const updatedSpotlights = new Map(prev);
			updatedSpotlights.delete(spotlightId);
			return updatedSpotlights;
		});
	};

	const getSpotlight = (id: string, mediaId: number) => {
		const spotlightId = `spotlight-${id}`;
		const newSpotlight = <Spotlight mediaId={mediaId} key={`spotlight-${spotlightId}`} spotlightId={spotlightId} elementToPortal={spotlightId} />;
		setSpotlights((prev) => new Map(prev).set(spotlightId, newSpotlight));
		return spotlightId;
	};

	const renderAllSpotlights = () => (
            <>
                {Array.from(spotlights.values()).map((spotlight) => spotlight)}
            </>
	);

	return (
        <SpotlightContext.Provider value={
            {
            	getSpotlight, renderAllSpotlights, freeSpotlight, updateSpotlightPortal,
            }}>
            {children}
        </SpotlightContext.Provider>
	);
};

export default SpotlightContextProvider;
